module.exports = __webpack_public_path__ + "img/green_135.67c2148d.png";